import { render, staticRenderFns } from "./ChildInfoWidget.vue?vue&type=template&id=a9c0a578&scoped=true"
import script from "./ChildInfoWidget.vue?vue&type=script&lang=js"
export * from "./ChildInfoWidget.vue?vue&type=script&lang=js"
import style0 from "./ChildInfoWidget.vue?vue&type=style&index=0&id=a9c0a578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c0a578",
  null
  
)

/* custom blocks */
import block0 from "./ChildInfoWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports